var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wy-analytics-compare-metrics-chart-line"},[_c('div',{ref:"chart",attrs:{"id":("compare-metrics-" + (_vm.chartData.id))}})])}
var staticRenderFns = []

export { render, staticRenderFns }